import * as React from "react";
const SvgCreditcard = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.444 6.583a1.11 1.11 0 0 0-1.11 1.111v2h25.333v-2a1.11 1.11 0 0 0-1.111-1.11zm24.223 4.445H3.333v3.11h25.334zm0 4.444H3.333v8.222a1.11 1.11 0 0 0 1.111 1.112h23.112a1.11 1.11 0 0 0 1.11-1.112zM2 7.694A2.444 2.444 0 0 1 4.444 5.25h23.112A2.444 2.444 0 0 1 30 7.694v16a2.444 2.444 0 0 1-2.444 2.445H4.444A2.444 2.444 0 0 1 2 23.694zM5.556 20.14c0-.368.298-.667.666-.667h6.222a.667.667 0 0 1 0 1.334H6.222a.667.667 0 0 1-.666-.667m17.777 0c0-.368.299-.667.667-.667h1.778a.667.667 0 0 1 0 1.334H24a.667.667 0 0 1-.667-.667",
    clipRule: "evenodd"
  }
));
export default SvgCreditcard;
